
import request from '@/utils/ajax';


export function queryOrderInfo(data) {
  return request({
    url: '/api/hcPay/getOrderInfo',
    method: 'get',
    params: data,
  });
}





